import styled from 'styled-components';
import Image from 'global/Image';

export const Wrapper = styled.div<{ height?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ height = 'auto' }) => height};
`;

export const ErrorIcon = styled(Image)`
  width: 100px;
  height: auto;
  margin-bottom: 16px;
`;

export const InfoText = styled.p<{ color?: string }>`
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #333333;
  text-align: center;

  color: ${({ color = '#333333' }) => color};
`;
